var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":_vm.iconDefinition}})])}
var staticRenderFns = []

export { render, staticRenderFns }